import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { reimbursementSettingsRepository } from '@webapp/modules/expense/data-access/repositories/ReimbursementSettingsRepository'
import { requestableCategoryRepository } from '@webapp/modules/expense/data-access/repositories/RequestableCategoryRepository'
import { settingsRepository } from '@webapp/platform/finance'
import { GetExpenseRequestFormDataUseCase } from './GetExpenseRequestFormDataUseCase'

export const getExpenseRequestFormDataUseCase =
  new GetExpenseRequestFormDataUseCase({
    expenseRepository,
    reimbursementSettingsRepository,
    requestableCategoryRepository,
    settingsRepository,
  })

export {
  GetExpenseRequestFormDataUseCase,
  type ExpenseFormInitialData,
  type ExpenseFormInitialItemData,
  type GetExpenseRequestFormDataUseCaseResult,
} from './GetExpenseRequestFormDataUseCase'
